<div class="search-bar" appFocusOut (elementFocusOut)="onFocusOut()">
  <input
  tabindex="1"
  type="text"
  [(ngModel)]="searchTxt"
  (ngModelChange)="onChange()"
  placeholder="{{ placeHolder }}"
  />
  <i *ngIf="!searchTxt || !searchTxt.length" class="fa fa-search" aria-hidden="true"></i>
  <i *ngIf="searchTxt && searchTxt.length" class="fa fa-times-circle" aria-hidden="true" (click)="clear()"></i>
  <div class="search-bar-result" *ngIf="!hideList && items && searchTxt && searchTxt.length">
    <div
      tabindex="2"
      class="list cursor-pointer"
      *ngFor="let item of items; let i = index"
      (click)="onSelect(i)"
    >
    <span *ngIf="!type">
      {{item}}
    </span>
    <span *ngIf="type=== 'deposit'">
      <span class="disable-txt" *ngIf="item.name" innerHtml="{{ item.name | highlightText : searchTxt }}"></span>
    </span>
    <span class="users" *ngIf="type === 'user'">
      <span class="disable-txt" *ngIf="item.displayName" innerHtml="{{ item.displayName | highlightText : searchTxt }}"></span>
      <span class="disable-txt" *ngIf="item.jobTitle || item.currentPosition"><span>-</span>{{item.jobTitle || item.currentPosition }}</span>
      <span class="disable-txt" *ngIf="item.department"><span>-</span>{{item.department}}</span>
    </span>
    </div>
  </div>
</div>
